import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-task-show',
  templateUrl: './task-show.component.html',
  styleUrls: ['./task-show.component.scss']
})
export class TaskShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
